'use client';

import { c as _c } from "react/compiler-runtime";
import { formatCents } from 'betterplace-utils';
import { useLocale } from 'next-intl';
import { DonationAmountSumProps } from './types';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function DonationAmountSum(t0) {
  const $ = _c(6);
  const {
    precision,
    fields
  } = t0;
  const locale = useLocale();
  const values = useDonationFormValues(fields);
  let t1;
  if ($[0] !== locale || $[1] !== precision || $[2] !== values) {
    const cents = values.reduce(_temp, 0);
    t1 = formatCents(locale, cents, {
      precision
    });
    $[0] = locale;
    $[1] = precision;
    $[2] = values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <span>{t1}</span>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(sum, value) {
  return sum + Number(value ? value : 0);
}
export default DonationAmountSum;